import { useIntl } from 'react-intl';

export const useTermsMessages = () => {
  const intl = useIntl();

  return {
    clientAccessibility: intl.formatMessage({ defaultMessage: 'Website Accessibility' }),
    clientTerms: intl.formatMessage({ defaultMessage: 'Client Terms of Service' }),
    dmcaPolicy: intl.formatMessage({ defaultMessage: 'DMCA Policy' }),
    giveawayTerms: intl.formatMessage({ defaultMessage: 'Giveaway Terms' }),
    privacy: intl.formatMessage({ defaultMessage: 'Privacy Policy' }),
    terms: intl.formatMessage({ defaultMessage: 'Terms' }),
  };
};
